module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./../../../../node_modules/ng-annotate-loader/loader.js!./../../../../node_modules/babel-loader/lib/index.js!./build.js"));
	}, "build");
}


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?lazy&name=build!./example/app/components/build/build.js
// module id = 32
// module chunks = 40